import {Card, Carousel, Col, Container, Row} from "react-bootstrap";

const carouselImages = [
    {
        src: '/purmamarca.jpg',
        heading: 'Purmamarca, Argentina',
        paragraph: 'Un valle montañoso en la provincia de Jujuy, famoso por sus paisajes coloridos, historia precolombina y cultura andina.'
    }, {
        src: '/catedral.jpg',
        heading: 'Cerro Catedral, Argentina',
        paragraph: 'En Bariloche, es un destino popular para el esquí y el senderismo, rodeado de montañas y lagos.'
    }
    , {
        src: '/bg04.jpg',
        heading: 'Mar del Plata, Argentina',
        paragraph: 'Una ciudad balnearia en la costa atlántica, famosa por sus extensas playas y su vibrante vida nocturna.'
    }, {
        src: '/bg03.jpg',
        heading: 'Valle de Calamuchita, Argentina',
        paragraph: 'Ubicado en la provincia de Córdoba, rodeado de verdes montañas y ríos cristalinos, es ideal para el ecoturismo y actividades al aire libre.'
    }, {
        src: '/madryn.jpg',
        heading: 'Puerto Madryn, Argentina',
        paragraph: ' Una ciudad costera en la Patagonia, conocida por sus playas y la observación de ballenas en el Golfo Nuevo.'
    }, {
        src: '/bg06.jpg',
        heading: 'Valle de Uco, Argentina',
        paragraph: 'Ubicado en Mendoza, es famoso por sus viñedos y la impresionante vista de la Cordillera de los Andes.'
    }
];

const Main = ({children}) => {
    return (
        <section className={'pt-0 pb-4 my-0 main-section'}>
            <Container fluid>
                <Card className={'mt-4 py-4 px-2 main-card'}>
                    <Container fluid>
                        <Row>
                            {children}
                            <Col className={'border-1 border-black d-none d-md-flex'} md={8} sm={12}>
                                <Carousel className={'carousel'}>
                                    {
                                        carouselImages.map((image, index) => {
                                            return (
                                                <Carousel.Item className={'carousel-image'} key={index} style={{
                                                    backgroundImage: `url(${image.src})`,
                                                    backgroundPosition: 'center center'
                                                }}>
                                                    <Carousel.Caption>
                                                        <h3>{image.heading}</h3>
                                                        <p>{image.paragraph}</p>
                                                    </Carousel.Caption>
                                                </Carousel.Item>
                                            );
                                        })
                                    }
                                </Carousel>
                            </Col>
                        </Row>
                    </Container>
                </Card>
            </Container>
        </section>
    );
}
export default Main;